import bsModal from 'bootstrap/js/dist/modal';

export default {
  install: (app, options) => {
    const modals = [];

    const onShown = (id, callback) => {
      const modalEl = document.getElementById(id);

      modalEl.addEventListener('shown.bs.modal', event => {
        callback();
      });
    }

    const onHide = (id, callback) => {
      const modalEl = document.getElementById(id);

      modalEl.addEventListener('hide.bs.modal', event => {
        callback();
      });
    }

    const onHidden = (id, callback) => {
      const modalEl = document.getElementById(id);

      modalEl.addEventListener('hidden.bs.modal', event => {
        callback();
      });
    }

    const show = (id, options = { backdrop: true, focus: true, keyboard: true }, callback_route) => {
      const modalEl = document.getElementById(id);
      const modalIndex = modals.findIndex(element => element.id == id);

      if (modalIndex === -1) {
        const modalObject = new bsModal(modalEl, options);

        modals.push({
          'id': id,
          'object': modalObject
        });

        modalObject.show();
      } else {
        modals[modalIndex].object.show();
      }
    };

    const hide = id => {
      const modalIndex = modals.findIndex(element => element.id == id);
      modals[modalIndex].object.hide();
    }

    const modal = { modals, show, hide, onShown, onHide, onHidden };
    app.config.globalProperties.$modal = modal;
    app.provide('$modal', modal);
  }
}